import { render, staticRenderFns } from "./Spells.vue?vue&type=template&id=edd2134c&scoped=true&"
import script from "./Spells.vue?vue&type=script&lang=js&"
export * from "./Spells.vue?vue&type=script&lang=js&"
import style0 from "./Spells.vue?vue&type=style&index=0&id=edd2134c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd2134c",
  null
  
)

export default component.exports